import React, { useEffect, useState } from "react";
import { useForm, SubmitHandler, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { Form, FormContainer } from "./Login.styled";
import {
  Button,
  ButtonSizes,
  ButtonVariants,
} from "../../components/core/Button/Button";
import { FormField } from "../../components/core/FormField/FormField";
import { useAppDispatch } from "../../hooks/store.hook";
import { setIsAuthenticated } from "../../stores/actions/user.actions";
import PasswordInput from "../../components/core/PasswordInput/PasswordInput";
import AuthService from "../../services/api/auth/Auth.service";
import { ReactComponent as Logo } from "../../images/logo.svg";
import { BodyTyp } from "../../components/Typography/Typography";
import { theme } from "../../constants/StyledComponents";
import TextInput from "../../components/core/TextInput/TextInput";
import { useNavigate } from "react-router-dom";
import { Loader } from "../../components/core/Loader/Loader";

interface FormData {
  email: string;
  password: string;
}

const schema = yup
  .object({
    email: yup.string().required("Email è obbligatorio"),
    password: yup.string().required("Password è obbligatorio"),
  })
  .required();

export const Login = () => {
  const dispatch = useAppDispatch();
  const [error, setError] = useState("");
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const {
    handleSubmit,
    control,
    watch,
    formState: { errors },
  } = useForm<FormData>({
    resolver: yupResolver(schema),
  });

  const onSubmit: SubmitHandler<FormData> = async (data) => {
    try {
      setLoading(true);
      await AuthService.login(data.email, data.password);
      dispatch(setIsAuthenticated(true));
      navigate("/");
    } catch (error) {
      console.error(`Error: ${error}`);
      setError("Credenziali non valide");
    } finally {
      setLoading(false);
    }
  };

  const [email, password] = watch(["email", "password"]);

  useEffect(() => {
    setError("");
  }, [email, password]);

  return (
    <FormContainer>
      <Loader loading={loading}>
        <Form onSubmit={handleSubmit(onSubmit)} autoComplete="off">
          <div className="logo-container">
            <Logo />
          </div>
          <FormField error={errors.email?.message}>
            <Controller
              name="email"
              control={control}
              render={({ field }) => (
                <TextInput label="Email*" maxLength={255} {...field} />
              )}
            />
          </FormField>
          <FormField error={errors.password?.message}>
            <Controller
              name="password"
              control={control}
              render={({ field }) => (
                <PasswordInput label="Password*" {...field} />
              )}
            />
          </FormField>
          {error && (
            <div className="error-container">
              <BodyTyp color={theme.colors.red_1}>{error}</BodyTyp>
            </div>
          )}
          <Button
            type="submit"
            variant={ButtonVariants.PRIMARY}
            size={ButtonSizes.REGULAR}
            label="Login"
            $fullwidth
          />
        </Form>
      </Loader>
    </FormContainer>
  );
};
